// A QR code drawn in the browser (qrcode-generator; nothing leaves the page):
// an <img> of an SVG, so it stays sharp at any size and needs no canvas.
// Event-day devices (card 540f21a4): a device's pairing code, a device link.
import React, { useMemo } from 'react';
import qrcode from 'qrcode-generator';

export const qrSvg = (text) => {
  const qr = qrcode(0, 'M');
  qr.addData(String(text));
  qr.make();
  return qr.createSvgTag({ cellSize: 4, margin: 2, scalable: true });
};

const QrCode = ({ value, size = 200, label, className = '' }) => {
  const src = useMemo(() => (value ? `data:image/svg+xml;charset=utf-8,${encodeURIComponent(qrSvg(value))}` : ''), [value]);
  if (!src) return null;
  return <img className={`qr-code ${className}`.trim()} src={src} width={size} height={size} alt={label} data-qr={value} />;
};

export default QrCode;
